import { render, staticRenderFns } from "./BaseBtn.vue?vue&type=template&id=0b22c412"
import script from "./BaseBtn.vue?vue&type=script&lang=js"
export * from "./BaseBtn.vue?vue&type=script&lang=js"
import style0 from "./BaseBtn.vue?vue&type=style&index=0&id=0b22c412&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports